module.exports = __webpack_public_path__ + "static/img/videoPage.8e98131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/videoPage.png
// module id = KolC
// module chunks = 1